import dynamic from 'next/dynamic';

import useVariant from 'utils/varify/useVariant';

const VehicleFlagsVariation = dynamic(
  () =>
    import(
      'components/section-components/reservation/Group/VehicleFlags/test_files/variation/VehicleFlags'
    ),
  {ssr: false},
);
const VehicleFlagsBase = dynamic(
  () =>
    import(
      'components/section-components/reservation/Group/VehicleFlags/test_files/base/VehicleFlags'
    ),
);

export const VehicleFlags = props => {
  const experimentId = '17653';
  const {isVariation} = useVariant({experimentId, variationId: null});
  return isVariation ? <VehicleFlagsVariation {...props} /> : <VehicleFlagsBase {...props} />;
};
